type SentryUser = {
  id: string
}

type UserId = string | number

type AuthStoreWithUser<TUser> = {
  getState: () => {
    user: TUser | null
  }
  subscribe: (listener: () => void) => void
}

interface SetupSentryUserIdSyncParams<TUser> {
  authStore: AuthStoreWithUser<TUser>
  getUserId: (user: TUser) => UserId | null | undefined
  setSentryUser: (user: SentryUser | null) => void
}

export const setupSentryUserIdSync = <TUser>({
  authStore,
  getUserId,
  setSentryUser,
}: SetupSentryUserIdSyncParams<TUser>) => {
  const sync = () => {
    const { user } = authStore.getState()

    if (!user) {
      setSentryUser(null)

      return
    }

    const userId = getUserId(user)

    if (userId === null || userId === undefined) {
      setSentryUser(null)

      return
    }

    setSentryUser({
      id: String(userId),
    })
  }

  sync()

  return authStore.subscribe(sync)
}
